import { SecureRoute } from "@okta/okta-react";
import { useEffect, useMemo } from "react";
import { Switch } from "react-router-dom/cjs/react-router-dom.min";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { LinearProgress } from "@deere/fuel-react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserDetails } from "../store/reducers/userReducer";
import { fetchDropdowns } from "../store/slices/extension";
import {
  ROLES,
  ROUTE_EXTENSION_BP,
  ROUTE_DM,
  ROUTE_EXTENSION_ERRORS,
  ROUTE_EXTENSION_JDF,
  ROUTE_EXTENSION_LOGS,
  ROUTE_EXTENSION_MANUAL_REQUEST,
  ROUTE_HOME,
  ROUTE_IB_BKP,
  VALID_ROUTES,
  TRANSLATIONS,
  ROUTE_IB_CCM,
  ROUTE_IB_BP,
  ROUTE_IB_CACLC,
  ROUTE_BN_ERROR,
  ROUTE_BN_ACCOUNTING,
  ROUTE_BN_UPLOAD,
  ROUTE_BN_SUCESS,
  ROUTE_REPORT_BANK,
  ROUTE_REPORT_DEALER,
  ROUTE_REPORT_MONTHLY_EXTENSION,
  ROUTE_REPORT_MONTHLY_EXTENSION_IEEFTI,
  ROUTE_REPORT_CUSTOMER_INTEREST_DRILLDOWN,
  ROUTE_DASHBOARD_BP,
  ROUTE_DASHBOARD_ADMIN,
  ROUTE_DASHBOARD_CCM,
} from "../constants/constant";
import HomePage from "./extension/home";
import BusinessProcessPage from "./extension/business-process";
import JDFPage from "./extension/jdf";
import LogsPage from "./extension/logs";
import ErrorPage from "./extension/errors";
import ManualRequest from "./manualRequest";
import TopNav from "../common/top-nav";
import { getUserRole } from "../utils/utils";
import BankPersonal from "./interestBearing/bankPersonal";
import DataManagement from "./data-management/DataManagement";
import { TranslationProvider } from "../common/translation-context";
import RatesAllocation from "./interestBearing/RatesAllocation";
import RatesDashboard from "./interestBearing/ratesDashboard";
import CalculationPage from "./calculation/calculationPage";
import UploadDebits from "../billnow/uploadDebits";
import ReviewAndApproveTransactions from "../billnow/review-and-approve";
import AccountingApproval from "../billnow/accountingApproval";
import SucessfulTransactions from "../billnow/successfulTransactions";
import BankRateReport from "./report/BankRateReport";
import DealerRateAllocationReport from "./report/DealerRateAllocationReport";
import MonthlyExtensionReport from "./report/MonthlyExtensionReport";
import MonthlyExtensionIEEFTIReport from "./report/monthly-extension-ieefti";
import CustomerInterestDrilldownReport from "./report/CustomerInterestDrilldownReport";
import BPDashboard from "./dashboard/BPDashboard";
import CCMDashboard from "./dashboard/ccm/CCMDashboard";
import AdminDashboard from "./dashboard/AdminDashboard";

function AppSwitch() {
  const dispatch = useDispatch();
  const history = useHistory();
  const userData = useSelector((state) => state.userState.userData);

  // Fetch global data once on app mount
  useEffect(() => {
    dispatch(fetchUserDetails());
    dispatch(fetchDropdowns());
  }, [dispatch]);

  useEffect(() => {
        if (!userData) {
          return;
        }
    if (userData) {
      const path = window.location.pathname;
      const userRole = getUserRole(userData);

      // If user is BKP and on a dashboard page, redirect to IB_BKP
      if (userRole === ROLES.BKP && 
          (path === ROUTE_DASHBOARD_BP || 
           path === ROUTE_DASHBOARD_ADMIN || 
           path === ROUTE_DASHBOARD_CCM)) {
        history.replace(ROUTE_IB_BKP);
        return;
      }

      if (
        (userRole === ROLES.BP ||
          userRole === ROLES.ADMIN ||
          userRole === ROLES.CCM) &&
        VALID_ROUTES.indexOf(path) > -1
      ) {
        return;
      } else if (userRole === ROLES.BKP) {
        history.replace(ROUTE_IB_BKP);
      } else if (userRole === ROLES.BN_ADMIN) {
        history.replace(ROUTE_BN_ERROR);
      } else if (userRole === ROLES.BP) {
        // Keep BP dashboard active
        history.replace(ROUTE_DASHBOARD_BP);
      } else if (userRole === ROLES.ADMIN) {
        history.replace(ROUTE_DASHBOARD_ADMIN);
      } else if (userRole === ROLES.CCM) {
        // Redirect CCM users to CCM dashboard
        history.replace(ROUTE_DASHBOARD_CCM);
      } else {
        history.replace(ROUTE_HOME);
      }
    } else {
      history.replace(ROUTE_HOME);
    }
    sessionStorage.clear();
  }, [userData, history]);

  // Memoize the user role to prevent unnecessary re-renders
  const userRole = useMemo(() => {
    return userData ? getUserRole(userData) : null;
  }, [userData]);

  const shouldShowTopNav = useMemo(() => {
    return userData &&
      (userRole === ROLES.BP ||
       userRole === ROLES.CCM ||
       userRole === ROLES.ADMIN ||
       userRole === ROLES.BKP ||
       userRole === ROLES.BN_ADMIN ||
       userRole === ROLES.JDU_ADMIN ||
       userRole === ROLES.BN_USER);
  }, [userData, userRole]);

  return (
    <>
      {shouldShowTopNav && <TopNav />}
      {userData ? (
        <div className="body-container">
          <Switch>
            <SecureRoute exact path={ROUTE_DASHBOARD_BP} key="BPDashboard">
              <TranslationProvider translationFile={TRANSLATIONS.GLOBAL}>
                <BPDashboard />
              </TranslationProvider>
            </SecureRoute>

            <SecureRoute exact path={ROUTE_DASHBOARD_ADMIN} key="AdminDashboard">
              <TranslationProvider translationFile={TRANSLATIONS.GLOBAL}>
                <AdminDashboard />
              </TranslationProvider>
            </SecureRoute>

            <SecureRoute exact path={ROUTE_DASHBOARD_CCM} key="CCMDashboard">
              <TranslationProvider translationFile={TRANSLATIONS.GLOBAL}>
                <CCMDashboard />
              </TranslationProvider>
            </SecureRoute>


            <SecureRoute exact path={ROUTE_HOME} key="HomePage">
              <TranslationProvider translationFile={TRANSLATIONS.GLOBAL}>
                <HomePage />
              </TranslationProvider>
            </SecureRoute>
            <SecureRoute
              exact
              path={ROUTE_EXTENSION_BP}
              key="BusinessProcessPage"
            >
              <TranslationProvider translationFile={TRANSLATIONS.EXTENSION}>
                <BusinessProcessPage />
              </TranslationProvider>
            </SecureRoute>
            <SecureRoute exact path={ROUTE_EXTENSION_JDF} key="JDFPage">
              <TranslationProvider translationFile={TRANSLATIONS.EXTENSION}>
                <JDFPage />
              </TranslationProvider>
            </SecureRoute>
            <SecureRoute exact path={ROUTE_EXTENSION_LOGS} key="LogsPage">
              <TranslationProvider translationFile={TRANSLATIONS.EXTENSION}>
                <LogsPage />
              </TranslationProvider>
            </SecureRoute>
            <SecureRoute exact path={ROUTE_EXTENSION_ERRORS} key="ErrorPage">
              <TranslationProvider translationFile={TRANSLATIONS.EXTENSION}>
                <ErrorPage />
              </TranslationProvider>
            </SecureRoute>
            <SecureRoute exact path={ROUTE_EXTENSION_MANUAL_REQUEST} key="ManualRequest">
              <TranslationProvider translationFile={TRANSLATIONS.EXTENSION}>
                <ManualRequest />
              </TranslationProvider>
            </SecureRoute>

            <SecureRoute exact path={ROUTE_DM} key="DataManagement">
              <TranslationProvider
                translationFile={TRANSLATIONS.DATA_MANAGEMENT}
              >
                <DataManagement />
              </TranslationProvider>
            </SecureRoute>

            <SecureRoute exact path={ROUTE_IB_BKP} key="BankPersonal">
              <TranslationProvider
                translationFile={TRANSLATIONS.INTEREST_BEARING}
              >
                <BankPersonal />
              </TranslationProvider>
            </SecureRoute>

            <SecureRoute exact path={ROUTE_IB_CCM} key="ratesAllocation">
              <TranslationProvider
                translationFile={TRANSLATIONS.INTEREST_BEARING}
              >
                <RatesAllocation />
              </TranslationProvider>
            </SecureRoute>

            <SecureRoute exact path={ROUTE_IB_BP} key="ratesDashboard">
              <TranslationProvider
                translationFile={TRANSLATIONS.INTEREST_BEARING}
              >
                <RatesDashboard />
              </TranslationProvider>
            </SecureRoute>

            <SecureRoute exact path={ROUTE_REPORT_BANK} key="bankReport">
              <TranslationProvider translationFile={TRANSLATIONS.REPORT}>
                <BankRateReport />
              </TranslationProvider>
            </SecureRoute>

            <SecureRoute exact path={ROUTE_REPORT_DEALER} key="dealerReport">
              <TranslationProvider translationFile={TRANSLATIONS.REPORT}>
                <DealerRateAllocationReport />
              </TranslationProvider>
            </SecureRoute>

            <SecureRoute exact path={ROUTE_REPORT_MONTHLY_EXTENSION} key="monthlyExtensionReport">
              <TranslationProvider translationFile={TRANSLATIONS.REPORT}>
                <MonthlyExtensionReport />
              </TranslationProvider>
            </SecureRoute>

            <SecureRoute exact path={ROUTE_REPORT_MONTHLY_EXTENSION_IEEFTI} key="monthlyExtensionIEEFTIReport">
              <TranslationProvider translationFile={TRANSLATIONS.REPORT}>
                <MonthlyExtensionIEEFTIReport />
              </TranslationProvider>
            </SecureRoute>

            <SecureRoute exact path={ROUTE_REPORT_CUSTOMER_INTEREST_DRILLDOWN} key="customerInterestDrilldownReport">
              <TranslationProvider translationFile={TRANSLATIONS.REPORT}>
                <CustomerInterestDrilldownReport />
              </TranslationProvider>
            </SecureRoute>

            <SecureRoute
              exact
              path={ROUTE_BN_ERROR}
              key="ReviewAndApproveTransactions"
            >
              <ReviewAndApproveTransactions />
            </SecureRoute>

            <SecureRoute
              exact
              path={ROUTE_BN_ACCOUNTING}
              key="AccountingApproval"
            >
              <AccountingApproval />
            </SecureRoute>

            <SecureRoute exact path={ROUTE_BN_UPLOAD} key="UploadDebits">
              <UploadDebits />
            </SecureRoute>

            <SecureRoute
              exact
              path={ROUTE_BN_SUCESS}
              key="SuccessTransactions"
            >
              <SucessfulTransactions />
            </SecureRoute>

            <SecureRoute exact path={ROUTE_IB_CACLC} key="CalculationPage">
              <TranslationProvider
                translationFile={TRANSLATIONS.INTEREST_BEARING}
              >
                <CalculationPage />
              </TranslationProvider>
            </SecureRoute>
          </Switch>
        </div>
      ) : (
        <LinearProgress size="large" value={0} />
      )}
    </>
  );
}

export default AppSwitch;
